import React, { Component } from 'react';
import ToLetters from '../../ToLetters';
import axios from 'axios';
import { read_cookie, delete_cookie } from 'sfcookies';
import Axios from 'axios';
import MaskedInput1 from 'react-text-mask';
import TextMask from 'react-text-mask';
import emailMask from 'text-mask-addons/src/emailMask';
import ReCAPTCHA from 'react-google-recaptcha';
import BootstrapSwitchButton from 'bootstrap-switch-button-react';
import Select from 'react-select';
import InputInfo from '../InputInfo';
import MaskedInput from 'react-maskedinput';

class CentralHeatingAppend2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fullname: '',
      personal: '',
      address: '',
      phone_1: '',
      phone_2: '',
      email_1: '',
      email_2: '',
      addressto: '',
      cadastral: '',
      customer_firstname: '',
      customer_lastname: '',
      customer_personal: '',
      customer_phone_1: '',
      customer_phone_2: '',
      customer_email_1: '',
      customer_email_2: '',
      custN: '',
      ownershipType: true,
      totalQuantity: '',
      household: '',
      nonhousehold: '',
      onlyHousehold: false,
      totalArea: '',
      detailedAppend1: false,
      detailedAppend2: false,
      detailedAppend3: false,
      hasAltElectricity: false,
      remoteTransmission: false,
      electricitySourceName: '',
      sourcePower: '',
      individualMeter: '',
      individualMeterQuantity: '',
      file_append1: '',
      file_append2: '',
      file_append4: '',
      file_systemDrawing: '',
      otherdocumentsfiles: [],
      file_1: '',
      agree: false,
      checked: true,
      errors: [],
      reference_FieldsDescriptions: [],
      reference_devices: [],
      reference_districts: [],
      reference_streets: [],
      reference_activestreest: [],
      metersList: [{ meterTypeNumber: '', stateRegistrationNumber: '' }],
      addressto_building: '',
      addressto_entrance: '',
      addressto_floor: '',
      addressto_apartament: '',
      district_Id: '',
      street_Id: '',
      street_Name: '',
      recaptchaCode: '',
      recaptchaCodeerror: '',
      reference_activedistricts: {},
      reference_activestreets_1: {},
      reference_RefCapacitySteps: [],
      reference_activeSteps: {},
      reference_tools: [],
      reference_allStreets: {},
    };
    this.handleLetterTermsModal = this.props.handleLetterTermsModal;
    this.letterFormValidator = this.props.letterFormValidator;
    this.renderCustomersOptions = this.props.renderCustomersOptions;
    this.SendLetter = this.props.SendLetter;
    this.handleSwalPopup = this.props.handleSwalPopup;
    this.checkGeorgianLetters = this.props.checkGeorgianLetters;
  }

  componentWillUnmount() {
    // fix Warning: Can't perform a React state update on an unmounted component
    this.setState = (state, callback) => {
      return;
    };
  }

  UNSAFE_componentWillMount() {
    const token = read_cookie('Bearer_Token');
    const url = window.$name;

    axios
      .get(`${url}/api/Letters/GetLetterFieldDescriptions/${this.props.letterTypeId}`, {
        headers: {
          Token: token,
        },
      })
      .then((res) => {
        //console.log(res);
        if (res.data.success) {
          this.setState({ reference_FieldsDescriptions: res.data.descriptions });
        }
      })
      .catch((error) => {
        if (typeof error.response !== 'udnefined') {
          if (error.response.status === 401) {
            delete_cookie('Bearer_Token');
            window.location.replace('/login');
          }
        }
      });
    if (typeof this.props.params.user !== 'undefined') {
      const data = this.props.params.user;
      //console.log(data);
      let phone = data.phones.filter((x) => x.typeKey === 1);
      let email = data.emails[0];
      //console.log(phone)
      this.setState({
        fullname: data.name + ' ' + data.lastName,
        personal: data.personalId,
        phone_1: phone ? phone[0].info : '',
        email_1: email ? email.info : '',
        address: data.registrationAddress,
      });
    }
  }

  componentDidMount() {
    const token = read_cookie('Bearer_Token');
    const name = window.$name;
    Axios.get(`${name}/api/Letters/GetReferences?letterTypeId=50`, {
      headers: { Token: token },
    })
      .then((res) => {
        if (res.data.success) {
          let data = res.data.references;
          let districts = [];
          let activedistricts = [];
          let streets = [];
          let devices = [];
          let active_streets = [];
          let RefCapacitySteps = [];
          let tools = [];
          let priceNames = [];
          let allStreets = [];
          let allActiveStreets = [];
          //ერთეულოვანისთვის "RefCapacitySteps":  1-თვითმმართველი ,2-არათვითმმართველი 3და 4 სიმძლავრის გაზრდაა
          //console.log(data);
          data.forEach((element) => {
            switch (element.key) {
              case 'RefDevices':
                devices.push(element);
                let obj1 = { value: element.id, label: element.value };
                tools.push(obj1);
                break;
              case 'RefDistricts':
                let obj = { value: element.id, label: element.value };
                activedistricts.push(obj);
                districts.push(element);
                break;
              case 'RefStreets':
                streets.push(element);
                allStreets.push(element);
                break;
              case 'RefCapacitySteps':
                RefCapacitySteps.push(element);
                //console.log(element);
                break;
              case 'RefPriceNames':
                priceNames.push(element);
                //console.log(element);
                break;
              default:
                break;
            }
          });
          //console.log(devices);
          let val = districts[0].id;
          streets.forEach((element) => {
            if (element.parentId === val) {
              active_streets.push(element);
            }
          });

          //console.log(allStreets);

          allStreets.forEach((element) => {
            if (element.id !== 12797 && element.id !== 14610) {
              let distName = districts.find((c) => c.id == element.parentId)?.value
                ? districts.find((c) => c.id == element.parentId)?.value
                : ' ';
              element.labelText = element.value + ' (' + distName + ')';
              element.districtName = distName;
              let lObj = {
                value: element.id,
                label: element.labelText,
                districtId: element.parentId,
                districtName: distName,
              };
              allActiveStreets.push(lObj);
            }
          });
          //let tmp = allStreets.slice(50,100);
          //console.log(tmp)
          //active_streets = allStreets.slice(100,150);

          //console.log(active_streets);
          this.setState({
            reference_devices: devices,
            reference_streets: streets,
            reference_districts: districts,
            reference_activestreest: active_streets,
            reference_activedistricts: activedistricts,
            reference_RefPriceNames: priceNames,
            reference_RefCapacitySteps: RefCapacitySteps,
            reference_tools: tools,
            reference_allStreets: allActiveStreets,
          });
          //console.log(this.state.priceNames);

          //this.setActiveSteps(1, RefCapacitySteps);
        }
      })
      .catch((error) => {
        //console.log(error);
        if (error.response.status === 401) {
          delete_cookie('Bearer_Token');
          window.location.replace('/login');
        }
        //alert("შეცდომა ?");
      });
  }

  handleChange = (input) => (e) => {
    let ph = '';
    if (input.includes('phone')) {
      ph = e.target.value.replace(/\D/g, '');
      if (input === 'phone_1') this.setState({ phone_1: ph });
      else if (input === 'phone_2') this.setState({ phone_2: ph });
      else if (input === 'customer_phone_1') this.setState({ customer_phone_1: ph });
      else this.setState({ customer_phone_2: ph });
    } else if (input === 'cadastral') {
      let val = e.target.value;
      const regex = /(\b\d{2,3}\b)|[0-9]{2,3}/g;
      let validationResult = true;
      if (val) {
        let t1 = val.replaceAll(',', '.');
        let t2 = t1.replaceAll('/', '.');

        let res = t2.match(regex);

        let splited = t2.split('.');

        if (splited.length < 3) {
          this.setState({ cadastral: t2, cadastralerror: 'არასწორი საკადასტრო კოდი' });
          validationResult = false;
        }

        if (res && splited && splited[splited.length - 1].length < 5) {
          if (res.length != splited.length) {
            this.setState({ cadastral: t2, cadastralerror: 'არასწორი საკადასტრო კოდი' });
            validationResult = false;
          }
        }

        if (splited.length > 3) {
          const response = this.checkGeorgianLetters(t2);
          if (splited[splited.length - 1].length > 6) {
            this.setState({ cadastral: t2, cadastralerror: 'არასწორი საკადასტრო კოდი' });
            validationResult = false;
          }
          if (!response) {
            this.setState({ cadastral: t2, cadastralerror: 'არასწორი საკადასტრო კოდი' });
            validationResult = false;
          }
        }

        if (validationResult) {
          this.setState({ [input]: t2, cadastralerror: '' });
        }
      } else {
        this.setState({ [input]: e.target.value });
      }
    } else if (input === 'recaptchaCode') {
      //console.log(e)
      this.setState({ recaptchaCode: e });
    } else {
      if (!this.state.checked) {
        if (input === 'customer_firstname') {
          this.setState({ customer_lastname: e.target.value });
        }
      }
      this.setState({ [input]: e.target.value });
    }
  };

  handleDistrictChange = (selectedOption) => {};

  handleStreetChange = (selectedOption) => {
    //console.log(selectedOption);
    if (selectedOption !== null)
      this.setState({
        street_Id: selectedOption !== null ? selectedOption.value : '',
        street_Name: selectedOption !== null ? selectedOption.label : '',
        district_Id: selectedOption != null ? selectedOption.districtId : '',
      });
    else {
      this.setState({ street_Id: '', street_Name: '', district_Id: '' });
    }
  };

  handleCheck(name) {
    //console.log(name)
    switch (name) {
      case 'checkyes_4':
        this.setState({ checkyes_4: !this.state.checkyes_4 });
        break;
      case 'checkyes_6':
        this.setState({ checkyes_6: !this.state.checkyes_6 }, function () {
          if (this.state.checkyes_6) this.setState({ checkyes_4: false });
          if (!this.state.checkyes_6) {
            this.setState({ checkyes_14_1: false, checkyes_14: true });
          }
        });
        break;
      case 'checkyes_16':
        this.setState({ checkyes_16: !this.state.checkyes_16 });
        break;
      case 'checkyes_18':
        this.setState({ checkyes_18: !this.state.checkyes_18 });
        break;
      case 'agree':
        this.setState({ agree: !this.state.agree });
        break;
      case 'checked':
        this.setState({ checked: !this.state.checked });
        break;
      case 'ownershipType':
        this.setState({ ownershipType: !this.state.ownershipType });
        break;
      case 'onlyHousehold':
        this.setState({ onlyHousehold: !this.state.onlyHousehold });
        break;
      case 'detailedAppend1':
        this.setState({ detailedAppend1: !this.state.detailedAppend1 });
        break;
      case 'detailedAppend2':
        this.setState({ detailedAppend2: !this.state.detailedAppend2 });
        break;
      case 'detailedAppend3':
        this.setState({ detailedAppend3: !this.state.detailedAppend3 });
        break;
      case 'individualMeter':
        this.setState({ individualMeter: !this.state.individualMeter });
        break;
      case 'hasAltElectricity':
        this.setState({ hasAltElectricity: !this.state.hasAltElectricity });
        break;
      default:
        break;
    }
  }

  handleFileChange = (input) => (event) => {
    if (input === 'otherdocumentsfiles') {
      if (event.target.files.length > 3) {
        this.handleSwalPopup(
          'ფაილების მაქსიმალური რაოდენობა არის 3',
          'warning',
          false,
          '',
          'დახურვა',
          false,
          '#262262'
        );
        document.getElementById('otherdocumentsfiles').value = '';
        //this.setState({[input]:[]});
      } else {
        this.setState({ [input]: event.target.files });
      }
    } else {
      this.setState({ [input]: event.target.files[0] });
    }
  };

  handleRepeat = () => {
    if (this.state.checked) {
      if (typeof this.props.params.user !== 'undefined') {
        const data = this.props.params.user;
        this.setState({
          customer_firstname: data.name,
          customer_personal: this.state.personal,
          customer_lastname: data.lastName,
          customer_phone_1: this.state.phone_1,
          customer_phone_2: this.state.phone_2,
          customer_email_1: this.state.email_1,
          customer_email_2: this.state.email_2,
        });
      }
    } else {
      this.setState({
        customer_phone_1: this.state.phone_1,
        customer_phone_2: this.state.phone_2,
        customer_email_1: this.state.email_1,
        customer_email_2: this.state.email_2,
      });
    }
  };

  handleInputChange = (e, index) => {
    const { name, value } = e.target;
    const list = [...this.state.metersList];
    list[index][name] = value;
    this.setState({ metersList: list });
  };

  handleAddClick = () => {
    this.setState({
      metersList: [...this.state.metersList, { meterTypeNumber: '', stateRegistrationNumber: '' }],
    });
  };

  handleRemoveClick = (index) => {
    this.state.metersList.splice(index, 1);
    this.setState({ metersList: this.state.metersList });
  };

  handlePhysicalSwitch = () => {
    if (this.state.checked) {
      this.setState({
        checked: !this.state.checked,
        customer_firstname: '',
        customer_lastname: '',
        customer_personal: '',
      });
    } else {
      this.setState({ checked: !this.state.checked });
    }
  };

  formValidate = () => {
    const values = this.state;
    //document.getElementById('SendButton').disabled=true;
    let data = [];

    for (const [key, value] of Object.entries(values)) {
      if (!key.includes('recap') && !key.includes('refe') && !key.includes('error')) {
        let obj = {};
        obj.name = key;
        obj.value = value;
        if (
          key === 'fullname' ||
          key === 'personal' ||
          key === 'custN' ||
          key === 'phone_1' ||
          key === 'file_1' ||
          key === 'address' ||
          key === 'cadastral' ||
          key === 'district_Id' ||
          key === 'street_Id' ||
          key === 'addressto_building' ||
          key === 'customer_firstname' ||
          key === 'customer_personal' ||
          key === 'customer_phone_1' ||
          key === 'totalQuantity' ||
          key === 'household' ||
          key === 'nonhousehold'
        )
          obj.Required = true;
        else if (key === 'customer_lastname') {
          if (this.state.checked == true) obj.Required = true;
          else obj.Required = false;
        } else if (key === 'file_append1') {
          if (this.state.detailedAppend1) obj.Required = true;
          else obj.Required = false;
        } else if (key === 'file_append2') {
          if (this.state.detailedAppend2) obj.Required = true;
          else obj.Required = false;
        } else if (key === 'sourcePower') {
          if (this.state.hasAltElectricity) obj.Required = true;
          else obj.Required = false;
        } else if (key === 'file_append4') {
          if (this.state.remoteTransmission) obj.Required = true;
          else obj.Required = false;
        } else if (key === 'file_systemDrawing') {
          if (this.state.detailedAppend3) obj.Required = true;
          else obj.Required = false;
        } else if (key === 'individualMeterQuantity') {
          if (this.state.individualMeter) obj.Required = true;
          else obj.Required = false;
        } else if (key === 'electricitySourceName') {
          if (this.state.hasAltElectricity) obj.Required = true;
          else obj.Required = false;
        } else obj.Required = false;

        data.push(obj);
      }
    }

    let result = this.letterFormValidator(this.props.letterTypeId, data);
    const found = result.errors.find((x) => x.key === 'filesSize');
    if (typeof found !== 'undefined') {
      //console.log(1234);
      this.state.errorFileSize = true;
      this.setState({ errors: result.errors });
      //this.handleSwalPopup("ფაილების ჯამური ზომა არ უნდა აღემატებოდეს 14MB-ს","warning",false,"","დახურვა",false,"#262262");
    } else {
      this.state.errorFileSize = false;
      this.setState({ errors: result.errors });
    }
    //console.log(result.errors);
    //document.getElementById('SendButton').disabled=false;
    //alert(result.isValid);
    return result.isValid;
  };

  handleSubmit = () => {
    let isValid = this.formValidate();
    //console.log(isValid);
    let data = [];

    let addressto = '';
    let buildingNum = this.state.addressto_building;
    let entrance = '';
    if (typeof this.state.addressto_entrance !== 'undefined')
      entrance += ', სად. ' + this.state.addressto_entrance;
    let floor = '';
    if (typeof this.state.addressto_floor !== 'undefined')
      floor += ', სართ. ' + this.state.addressto_floor;
    let apartament = '';
    if (typeof this.stateaddressto_apartament !== 'undefined')
      apartament += ', ბინა ' + this.state.addressto_apartament;
    addressto = this.state.street_Name + ' ' + buildingNum + entrance + floor + apartament;

    //console.log(addressto);

    if (isValid) {
      data.push({ key: 'addressto', value: addressto });
      for (const [key, value] of Object.entries(this.state)) {
        let obj = {};
        if (!key.includes('error') && !key.includes('refe') && !key.includes('recap')) {
          if (value !== '' && value !== null) {
            obj.key = key;
            obj.value = value;
            data.push(obj);
          }
        }
      }
      this.SendLetter(this.state.custN, this.props.letterTypeId, this.state.recaptchaCode, data);
    } else {
      //var filesError = this.state.errors.filter(x=>x.key==="filesSize"); if(filesError.length) filesError=filesError[0].value;
      if (this.state.errorFileSize) {
        this.handleSwalPopup(
          'ფაილების ჯამური ზომა არ უნდა აღემატებოდეს 14MB-ს',
          'warning',
          false,
          '',
          'დახურვა',
          false,
          '#262262'
        );
      } else {
        this.handleSwalPopup(
          'შესავსებია სავალდებულო ველები',
          'warning',
          false,
          '',
          'დახურვა',
          false,
          '#262262'
        );
      }
    }
  };

  errorExsist = (key) => {
    let bool = this.state.errors.some((obj) => obj.key == key);
    return bool;
  };

  renderErrorText = (key) => {
    let bool = this.state.errors.find((obj) => obj.key.includes(key) === true);
    return bool.value;
  };

  render() {
    const values = this.state;
    let phone, email;
    if (typeof this.props.params.user !== 'undefined') {
      const data = this.props.params.user;
      phone = data.phones.filter((x) => x.typeKey === 1);
      email = data.emails[0];
    }
    let l = true;
    if (values.reference_FieldsDescriptions.length === 0) l = false;

    return (
      <>
        <React.Fragment>
          <div className="row justify-content-center" style={{ fontFamily: 'BPGCond' }}>
            <div className="col-lg-12">
              <div className="card">
                <div className="card-header">
                  <div style={{ float: 'left' }}>
                    <ToLetters></ToLetters>
                  </div>
                  <div style={{ textAlign: 'center' }}>
                    <span>
                      <strong>{this.props.letterTitle}</strong>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-12">
              <div className="card">
                <div className="card-header">
                  <strong>განმცხადებელი</strong>
                </div>
                <div className="card-body">
                  <div className="form-horizontal">
                    <div className="form-group row">
                      <label className="col-md-4 col-form-label">
                        <strong>სახელი და გვარი</strong>
                        <span style={{ color: '#e55353' }}>*</span>
                      </label>
                      <div className="col-md-8">
                        <input
                          className="form-control"
                          type="text"
                          id="name"
                          readOnly={this.props.params.user.fullName ? true : false}
                          placeholder="სახელი გვარი/ორგანიზაციის დასახელება"
                          onChange={this.handleChange('fullname')}
                          value={values.fullname}
                        ></input>
                        {l ? (
                          <InputInfo
                            descriptions={values.reference_FieldsDescriptions}
                            letterTypeId={this.props.letterTypeId}
                            inputName={'fullname'}
                          />
                        ) : null}
                        {this.errorExsist('fullname') ? (
                          <label style={{ fontSize: 10, color: '#e55353' }}>
                            {this.renderErrorText('fullname')}
                          </label>
                        ) : null}
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-md-4 col-form-label">
                        <strong>პირადი #/საიდენტიფიკაციო #:</strong>
                        <span style={{ color: '#e55353' }}>*</span>
                      </div>
                      <div className="col-md-8">
                        <input
                          className="form-control"
                          type="text"
                          id="personal"
                          placeholder="პირადი ნომერი"
                          readOnly={this.props.params.user.personalId ? true : false}
                          onChange={this.handleChange('personal')}
                          value={values.personal}
                        ></input>
                        {l ? (
                          <InputInfo
                            descriptions={values.reference_FieldsDescriptions}
                            letterTypeId={this.props.letterTypeId}
                            inputName={'personal'}
                          />
                        ) : null}
                        {this.errorExsist('personal') ? (
                          <label style={{ fontSize: 10, color: '#e55353' }}>
                            {this.renderErrorText('personal')}
                          </label>
                        ) : null}
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-md-4 col-form-label">
                        <strong>მისამართი</strong>
                        <span style={{ color: '#e55353' }}>*</span>
                      </label>
                      <div className="col-md-8">
                        <input
                          className="form-control"
                          type="text"
                          id="address"
                          placeholder="მისამართი"
                          readOnly={this.props.params.user.registrationAddress ? true : false}
                          onChange={this.handleChange('address')}
                          value={values.address}
                        ></input>
                        {l ? (
                          <InputInfo
                            descriptions={values.reference_FieldsDescriptions}
                            letterTypeId={this.props.letterTypeId}
                            inputName={'address'}
                          />
                        ) : null}
                        {this.errorExsist('address') ? (
                          <label style={{ fontSize: 10, color: '#e55353' }}>
                            {this.renderErrorText('address')}
                          </label>
                        ) : null}
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-md-4 col-form-label">
                        <strong>მობილური (ძირითადი)</strong>
                        <span style={{ color: '#e55353' }}>*</span>
                      </label>
                      <div className="col-md-8">
                        <MaskedInput1
                          readOnly={
                            typeof phone[0].info !== 'undefined' && phone[0].info ? true : false
                          }
                          mask={[
                            '(',
                            /[0-9]/,
                            /\d/,
                            /\d/,
                            ')',
                            ' ',
                            /\d/,
                            /\d/,
                            /\d/,
                            '-',
                            /\d/,
                            /\d/,
                            /\d/,
                          ]}
                          guide={true}
                          className="form-control"
                          type="text"
                          placeholder="მობილურის ნომერი"
                          name="phone_1"
                          onChange={this.handleChange('phone_1')}
                          value={values.phone_1}
                        ></MaskedInput1>
                        {l ? (
                          <InputInfo
                            descriptions={values.reference_FieldsDescriptions}
                            letterTypeId={this.props.letterTypeId}
                            inputName={'phone_1'}
                          />
                        ) : null}
                        {this.errorExsist('phone_1') ? (
                          <label style={{ fontSize: 10, color: '#e55353' }}>
                            {this.renderErrorText('phone_1')}
                          </label>
                        ) : null}
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-md-4 col-form-label">
                        <strong>მობილური (ალტერნატიული)</strong>
                      </label>
                      <div className="col-md-8">
                        <MaskedInput1
                          mask={[
                            '(',
                            /[0-9]/,
                            /\d/,
                            /\d/,
                            ')',
                            ' ',
                            /\d/,
                            /\d/,
                            /\d/,
                            '-',
                            /\d/,
                            /\d/,
                            /\d/,
                          ]}
                          guide={true}
                          className="form-control"
                          type="text"
                          placeholder="მობილურის ნომერი"
                          name="phone_2"
                          onChange={this.handleChange('phone_2')}
                          value={values.phone_2}
                        ></MaskedInput1>
                        {l ? (
                          <InputInfo
                            descriptions={values.reference_FieldsDescriptions}
                            letterTypeId={this.props.letterTypeId}
                            inputName={'phone_2'}
                          />
                        ) : null}
                        {this.errorExsist('phone_2') ? (
                          <label style={{ fontSize: 10, color: '#e55353' }}>
                            {this.renderErrorText('phone_2')}
                          </label>
                        ) : null}
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-md-4 col-form-label">
                        <strong>ელ. ფოსტა (ძირითადი)</strong>
                      </label>
                      <div className="col-md-8">
                        <TextMask
                          readOnly={typeof email !== 'undefined' ? true : false}
                          className="form-control"
                          placeholder="ელ. ფოსტა"
                          name="email_1"
                          onChange={this.handleChange('email_1')}
                          value={values.email_1}
                          mask={emailMask.mask}
                          pipe={emailMask.pipe}
                        />
                        {l ? (
                          <InputInfo
                            descriptions={values.reference_FieldsDescriptions}
                            letterTypeId={this.props.letterTypeId}
                            inputName={'email_1'}
                          />
                        ) : null}
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-md-4 col-form-label">
                        <strong>ელ. ფოსტა (ალტერნატიული)</strong>
                      </label>
                      <div className="col-md-8">
                        <TextMask
                          className="form-control"
                          placeholder="ელ. ფოსტა"
                          name="email_2"
                          onChange={this.handleChange('email_2')}
                          value={values.email_2}
                          mask={emailMask.mask}
                          pipe={emailMask.pipe}
                        />
                        {l ? (
                          <InputInfo
                            descriptions={values.reference_FieldsDescriptions}
                            letterTypeId={this.props.letterTypeId}
                            inputName={'email_2'}
                          />
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-12">
              <div className="card">
                <div className="card-header">
                  <strong>ინფორმაცია აბონენტის შესახებ</strong>
                  <div className="card-header-actions">
                    <button className="btn btn-primary btn-sm" onClick={this.handleRepeat}>
                      განმცხადებლის მონაცემების გადმოტანა
                    </button>
                  </div>
                </div>
                <div className="card-body">
                  <div className="form-horizontal">
                    <BootstrapSwitchButton
                      width={200}
                      checked={values.checked}
                      onlabel="ფიზიკური"
                      offlabel="იურიდიული"
                      onChange={this.handlePhysicalSwitch}
                    ></BootstrapSwitchButton>
                    <br />
                    <br />
                    <div className="form-group row">
                      <label className="col-md-4 col-form-label">
                        <strong>{values.checked ? 'სახელი' : 'დასახელება'}</strong>
                        <span style={{ color: '#e55353' }}>*</span>
                      </label>
                      <div className="col-md-8">
                        <input
                          className="form-control"
                          onChange={this.handleChange('customer_firstname')}
                          placeholder={values.checked ? 'სახელი' : 'დასახელება'}
                          value={values.customer_firstname}
                        ></input>
                        {l ? (
                          <InputInfo
                            descriptions={values.reference_FieldsDescriptions}
                            letterTypeId={this.props.letterTypeId}
                            inputName={'customer_firstname'}
                          />
                        ) : null}
                        {this.errorExsist('customer_firstname') ? (
                          <label style={{ fontSize: 10, color: '#e55353' }}>
                            {this.renderErrorText('customer_firstname')}
                          </label>
                        ) : null}
                      </div>
                    </div>
                    {values.checked ? (
                      <div className="form-group row">
                        <label className="col-md-4 col-form-label">
                          <strong>გვარი</strong>
                          <span style={{ color: '#e55353' }}>*</span>
                        </label>
                        <div className="col-md-8">
                          <input
                            className="form-control"
                            onChange={this.handleChange('customer_lastname')}
                            value={values.customer_lastname}
                            placeholder="გვარი"
                          ></input>
                          {l ? (
                            <InputInfo
                              descriptions={values.reference_FieldsDescriptions}
                              letterTypeId={this.props.letterTypeId}
                              inputName={'customer_lastname'}
                            />
                          ) : null}
                          {this.errorExsist('customer_lastname') ? (
                            <label style={{ fontSize: 10, color: '#e55353' }}>
                              {this.renderErrorText('customer_lastname')}
                            </label>
                          ) : null}
                        </div>
                      </div>
                    ) : null}
                    <div className="form-group row">
                      <label className="col-md-4 col-form-label">
                        <strong>
                          {values.checked ? 'პირადი ნომერი' : 'საინდენტიფიკაციო ნომერი'}
                        </strong>
                        <span style={{ color: '#e55353' }}>*</span>
                      </label>
                      <div className="col-md-8">
                        <input
                          className="form-control"
                          onChange={this.handleChange('customer_personal')}
                          value={values.customer_personal}
                          placeholder={values.checked ? 'პირადი ნომერი' : 'საინდენტიფიკაციო ნომერი'}
                        ></input>
                        {l ? (
                          <InputInfo
                            descriptions={values.reference_FieldsDescriptions}
                            letterTypeId={this.props.letterTypeId}
                            inputName={'customer_personal'}
                          />
                        ) : null}
                        {this.errorExsist('customer_personal') ? (
                          <label style={{ fontSize: 10, color: '#e55353' }}>
                            {this.renderErrorText('customer_personal')}
                          </label>
                        ) : null}
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-md-4 col-form-label">
                        <strong>მობილურის ნომერი(ძირითადი)</strong>
                        <span style={{ color: '#e55353' }}>*</span>
                      </label>
                      <div className="col-md-8">
                        <MaskedInput1
                          mask={[
                            '(',
                            /[0-9]/,
                            /\d/,
                            /\d/,
                            ')',
                            ' ',
                            /\d/,
                            /\d/,
                            /\d/,
                            '-',
                            /\d/,
                            /\d/,
                            /\d/,
                          ]}
                          guide={true}
                          className="form-control"
                          type="text"
                          placeholder="ძირითადი"
                          name="customer_phone_1"
                          onChange={this.handleChange('customer_phone_1')}
                          value={values.customer_phone_1}
                        ></MaskedInput1>
                        {l ? (
                          <InputInfo
                            descriptions={values.reference_FieldsDescriptions}
                            letterTypeId={this.props.letterTypeId}
                            inputName={'customer_phone_1'}
                          />
                        ) : null}
                        {this.errorExsist('customer_phone_1') ? (
                          <label style={{ fontSize: 10, color: '#e55353' }}>
                            {this.renderErrorText('customer_phone_1')}
                          </label>
                        ) : null}
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-md-4 col-form-label">
                        <strong>მობილურის ნომერი(ალტერნატიული)</strong>
                      </label>
                      <div className="col-md-8">
                        <MaskedInput1
                          mask={[
                            '(',
                            /[0-9]/,
                            /\d/,
                            /\d/,
                            ')',
                            ' ',
                            /\d/,
                            /\d/,
                            /\d/,
                            '-',
                            /\d/,
                            /\d/,
                            /\d/,
                          ]}
                          guide={true}
                          className="form-control"
                          type="text"
                          placeholder="ალტერნატიული"
                          name="customer_phone_2"
                          onChange={this.handleChange('customer_phone_2')}
                          value={values.customer_phone_2}
                        ></MaskedInput1>
                        {l ? (
                          <InputInfo
                            descriptions={values.reference_FieldsDescriptions}
                            letterTypeId={this.props.letterTypeId}
                            inputName={'customer_phone_2'}
                          />
                        ) : null}
                        {this.errorExsist('customer_phone_2') ? (
                          <label style={{ fontSize: 10, color: '#e55353' }}>
                            {this.renderErrorText('customer_phone_2')}
                          </label>
                        ) : null}
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-md-4 col-form-label">
                        <strong>ელ. ფოსტა(ძირითადი)</strong>
                      </label>
                      <div className="col-md-8">
                        <TextMask
                          className="form-control"
                          placeholder="ძირითადი"
                          name="customer_email_1"
                          onChange={this.handleChange('customer_email_1')}
                          value={values.customer_email_1}
                          mask={emailMask.mask}
                          pipe={emailMask.pipe}
                        />
                        {l ? (
                          <InputInfo
                            descriptions={values.reference_FieldsDescriptions}
                            letterTypeId={this.props.letterTypeId}
                            inputName={'customer_email_1'}
                          />
                        ) : null}
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-md-4 col-form-label">
                        <strong>ელ. ფოსტა(ალტერნატიული)</strong>
                      </label>
                      <div className="col-md-8">
                        <TextMask
                          className="form-control"
                          placeholder="ალტერნატიული"
                          name="customer_email_2"
                          onChange={this.handleChange('customer_email_2')}
                          value={values.customer_email_2}
                          mask={emailMask.mask}
                          pipe={emailMask.pipe}
                        />
                        {l ? (
                          <InputInfo
                            descriptions={values.reference_FieldsDescriptions}
                            letterTypeId={this.props.letterTypeId}
                            inputName={'customer_email_2'}
                          />
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-12">
              <div className="card">
                <div className="card-header">
                  <strong>ინფორმაცია მისაერთებელი ობიექტის შესახებ</strong>
                </div>
                <div className="card-body">
                  <div className="form-horizontal">
                    <div className="form-group row">
                      <label className="col-md-4 col-from-label">
                        <strong>
                          უძრავი ქონების საკადასტრო კოდი
                          <span style={{ color: '#e55353' }}>*</span>
                        </strong>
                      </label>
                      <div className="col-md-8">
                        <input
                          className="form-control"
                          onChange={this.handleChange('cadastral')}
                          placeholder="უძრავი ქონების საკადასტრო კოდი"
                          value={values.cadastral}
                        ></input>
                        {l ? (
                          <InputInfo
                            descriptions={values.reference_FieldsDescriptions}
                            letterTypeId={this.props.letterTypeId}
                            inputName={'cadastral'}
                          />
                        ) : null}
                        {values.cadastralerror ? (
                          <label style={{ fontSize: 10, color: '#e55353' }}>
                            {values.cadastralerror}
                          </label>
                        ) : null}
                        {this.errorExsist('cadastral') ? (
                          <label style={{ fontSize: 10, color: '#e55353' }}>
                            {this.renderErrorText('cadastral')}
                          </label>
                        ) : null}
                      </div>
                    </div>
                  </div>
                  <div className="form-group row">
                    <label className="col-md-4 col-form-label">
                      <strong>
                        აბონენტის ნომერი, სადაც უნდა მოხდეს ბუნებრივი გაზის მოხმარების მოცულობის
                        გაზრდა
                      </strong>
                      <span style={{ color: '#e55353' }}>*</span>
                    </label>
                    <div className="col-md-8">
                      <MaskedInput
                        className="form-control"
                        mask="111111-111"
                        list="customers"
                        placeholder="XXXXXX-XXX"
                        name="custN"
                        onChange={this.handleChange('custN')}
                        value={values.custN}
                      ></MaskedInput>
                      {l ? (
                        <InputInfo
                          descriptions={values.reference_FieldsDescriptions}
                          letterTypeId={this.props.letterTypeId}
                          inputName={'custN'}
                        />
                      ) : null}
                      <datalist id="customers">{this.renderCustomersOptions()}</datalist>
                      {this.errorExsist('custN') ? (
                        <label style={{ fontSize: 10, color: '#e55353' }}>
                          {this.renderErrorText('custN')}
                        </label>
                      ) : null}
                      <span style={{ color: '#e55353' }}>
                        თუ ჩამონათვალში არ იძებნება ის აბონენტის ნომერი, სადაც გსურთ ბუნებრივი გაზის
                        მოხმარების მოცულობის გაზრდა, გთხოვთ პირად კაბინეტში დაამატოთ შესაბამისი
                        აბონენტის ნომერი და შემდგომ მოახდინოთ განაცხადის რეგისტრაცია.
                        <a href="/dashboard/Customers">აბონენტის დამატება</a>
                        {/* <a href="/dashboard/Write/AbonentRegister">
                        აბონენტის რეგისტრაციის მონაცემების ცვლილება
                      </a> */}
                      </span>
                    </div>
                  </div>
                  <div className="form-group row">
                    <label className="col-md-4 col-form-label">
                      <strong>ქუჩა</strong>
                      <span style={{ color: '#e55353' }}>*</span>
                    </label>
                    <div className="col-md-8">
                      <Select
                        ref={(ref) => {
                          this.selectRef1 = ref;
                        }}
                        isClearable
                        isSearchable
                        options={this.state.reference_allStreets}
                        onChange={this.handleStreetChange}
                        placeholder="აირჩიეთ ან აკრიფეთ"
                        noOptionsMessage={() => 'ცარიელია'}
                      />

                      {l ? (
                        <InputInfo
                          descriptions={values.reference_FieldsDescriptions}
                          letterTypeId={this.props.letterTypeId}
                          inputName={'street_Id'}
                        />
                      ) : null}
                      {this.errorExsist('street_Id') ? (
                        <label style={{ fontSize: 10, color: '#e55353' }}>
                          {this.renderErrorText('street_Id')}
                        </label>
                      ) : null}
                    </div>
                  </div>
                  <br />
                  <div className="form-group row">
                    <label className="col-md-4 col-form-label">
                      <strong>შენობის ნომერი</strong>
                      <span style={{ color: '#e55353' }}>*</span>
                    </label>
                    <div className="col-md-8">
                      <input
                        maxLength="50"
                        className="form-control"
                        onChange={this.handleChange('addressto_building')}
                        placeholder="შენობის ნომერი"
                        name="addressto_building"
                        value={values.addressto_building}
                      ></input>
                      {l ? (
                        <InputInfo
                          descriptions={values.reference_FieldsDescriptions}
                          letterTypeId={this.props.letterTypeId}
                          inputName={'addressto_building'}
                        />
                      ) : null}
                      {this.errorExsist('addressto_building') ? (
                        <label style={{ fontSize: 10, color: '#e55353' }}>
                          {this.renderErrorText('addressto_building')}
                        </label>
                      ) : null}
                    </div>
                  </div>
                  <div className="form-group row">
                    <label className="col-md-4 col-form-label">
                      <strong>სადარბაზო</strong>
                    </label>
                    <div className="col-md-8">
                      <input
                        maxLength="50"
                        className="form-control"
                        onChange={this.handleChange('addressto_entrance')}
                        placeholder="სადარბაზო"
                        name="addressto_entrance"
                        value={values.addressto_entrance}
                      ></input>
                      {l ? (
                        <InputInfo
                          descriptions={values.reference_FieldsDescriptions}
                          letterTypeId={this.props.letterTypeId}
                          inputName={'addressto_entrance'}
                        />
                      ) : null}
                    </div>
                  </div>
                  <div className="form-group row">
                    <label className="col-md-4 col-form-label">
                      <strong>სართული</strong>
                    </label>
                    <div className="col-md-8">
                      <input
                        maxLength="50"
                        className="form-control"
                        onChange={this.handleChange('addressto_floor')}
                        placeholder="სართული"
                        name="addressto_floor"
                        value={values.addressto_floor}
                      ></input>
                      {l ? (
                        <InputInfo
                          descriptions={values.reference_FieldsDescriptions}
                          letterTypeId={this.props.letterTypeId}
                          inputName={'addressto_floor'}
                        />
                      ) : null}
                    </div>
                  </div>
                  <div className="form-group row">
                    <label className="col-md-4 col-form-label">
                      <strong>ბინის ნომერი</strong>
                    </label>
                    <div className="col-md-8">
                      <input
                        maxLength="50"
                        className="form-control"
                        onChange={this.handleChange('addressto_apartament')}
                        placeholder="ბინის ნომერი"
                        name="addressto_apartament"
                        value={values.addressto_apartament}
                      ></input>
                      {l ? (
                        <InputInfo
                          descriptions={values.reference_FieldsDescriptions}
                          letterTypeId={this.props.letterTypeId}
                          inputName={'addressto_apartament'}
                        />
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-12">
              <div className="card">
                <div className="card-header">
                  <strong>სხვა პირობები</strong>
                </div>
                <div className="card-body">
                  <div className="form-group row">
                    <label className="col-md-4 col-form-label">
                      <strong>ცენტრალურ გათბობის სისტემის ფლობის ფორმა</strong>
                    </label>
                    <div className="col-md-8">
                      <label>
                        <input
                          type="radio"
                          onChange={() => {
                            this.handleCheck('ownershipType');
                          }}
                          checked={this.state.ownershipType}
                        ></input>
                        &nbsp;საკუთრების ფორმით
                      </label>
                      &nbsp;&nbsp;&nbsp;&nbsp;
                      <label>
                        <input
                          type="radio"
                          onChange={() => {
                            this.handleCheck('ownershipType');
                          }}
                          name="ownershipType"
                          checked={!this.state.ownershipType}
                        ></input>
                        &nbsp;დროებითი ფლობით
                      </label>
                      {l ? (
                        <InputInfo
                          descriptions={values.reference_FieldsDescriptions}
                          letterTypeId={this.props.letterTypeId}
                          inputName={'ownershipType'}
                        />
                      ) : null}
                    </div>
                  </div>
                  <div className="form-group row">
                    <label className="col-md-4 col-form-label">
                      <strong>
                        ცენტრალური გათბობით მოსარგებლე ობიექტების ჯამური რაოდენობა
                        <span style={{ color: '#e55353' }}>*</span>
                      </strong>
                    </label>
                    <div className="col-md-8">
                      <input
                        id="totalQuantity"
                        name="totalQuantity"
                        type="number"
                        className="form-control"
                        onChange={this.handleChange('totalQuantity')}
                        value={values.totalQuantity}
                        placeholder="რაოდენობა"
                        min="0"
                      />
                      {l ? (
                        <InputInfo
                          descriptions={values.reference_FieldsDescriptions}
                          letterTypeId={this.props.letterTypeId}
                          inputName={'totalQuantity'}
                        />
                      ) : null}
                      {this.errorExsist('totalQuantity') ? (
                        <label style={{ fontSize: 10, color: '#e55353' }}>
                          {this.renderErrorText('totalQuantity')}
                        </label>
                      ) : null}
                    </div>
                  </div>
                  <div className="form-group row">
                    <label className="col-md-4 col-form-label">
                      <strong>
                        საყოფაცხოვრებო<span style={{ color: '#e55353' }}>*</span>
                      </strong>
                    </label>
                    <div className="col-md-8">
                      <input
                        id="household"
                        name="household"
                        type="number"
                        className="form-control"
                        onChange={this.handleChange('household')}
                        value={values.household}
                        placeholder="რაოდენობა"
                        min="0"
                      />
                      {l ? (
                        <InputInfo
                          descriptions={values.reference_FieldsDescriptions}
                          letterTypeId={this.props.letterTypeId}
                          inputName={'household'}
                        />
                      ) : null}
                      {this.errorExsist('household') ? (
                        <label style={{ fontSize: 10, color: '#e55353' }}>
                          {this.renderErrorText('household')}
                        </label>
                      ) : null}
                    </div>
                  </div>
                  <div className="form-group row">
                    <label className="col-md-4 col-form-label">
                      <strong>
                        არასაყოფაცხოვრებო<span style={{ color: '#e55353' }}>*</span>
                      </strong>
                    </label>
                    <div className="col-md-8">
                      <input
                        id="nonhousehold"
                        name="nonhousehold"
                        type="number"
                        className="form-control"
                        onChange={this.handleChange('nonhousehold')}
                        value={values.nonhousehold}
                        placeholder="რაოდენობა"
                        min="0"
                      />
                      {l ? (
                        <InputInfo
                          descriptions={values.reference_FieldsDescriptions}
                          letterTypeId={this.props.letterTypeId}
                          inputName={'nonhousehold'}
                        />
                      ) : null}
                      {this.errorExsist('nonhousehold') ? (
                        <label style={{ fontSize: 10, color: '#e55353' }}>
                          {this.renderErrorText('nonhousehold')}
                        </label>
                      ) : null}
                    </div>
                  </div>
                  <div className="form-group row">
                    <label className="col-md-4 col-form-label">
                      <strong>
                        ცენტრალური გათბობის სისტემიდან მომარაგებული ჯამური ფართობი (მ
                        <sup>2</sup>)
                        {values.onlyHousehold ? <span style={{ color: '#e55353' }}>*</span> : null}
                      </strong>
                    </label>
                    <div className="col-md-8">
                      <input
                        id="totalArea"
                        name="totalArea"
                        type="number"
                        className="form-control"
                        onChange={this.handleChange('totalArea')}
                        value={values.totalArea}
                        placeholder="ფართობი"
                        min="0.1"
                      />
                    </div>
                    {l ? (
                      <InputInfo
                        descriptions={values.reference_FieldsDescriptions}
                        letterTypeId={this.props.letterTypeId}
                        inputName={'totalArea'}
                      />
                    ) : null}
                    {this.errorExsist('totalArea') ? (
                      <label
                        style={{
                          fontSize: 10,
                          color: '#e55353',
                        }}
                      >
                        {this.renderErrorText('totalArea')}
                      </label>
                    ) : null}
                  </div>
                  <div className="form-group row">
                    <label className="col-md-4 col-form-label">
                      <strong>
                        სარგებლობს თუ არა ცენტრალური გათბობის სისტემა განახლებადი ან/და ალტერნატიული
                        ენერგიის წყაროთი
                      </strong>
                    </label>
                    <div className="col-md-8">
                      <input
                        type="checkbox"
                        onChange={() => this.handleCheck('hasAltElectricity')}
                        checked={values.hasAltElectricity}
                      ></input>
                      &nbsp;დიახ
                      {l ? (
                        <InputInfo
                          descriptions={values.reference_FieldsDescriptions}
                          letterTypeId={this.props.letterTypeId}
                          inputName={'hasAltElectricity'}
                        />
                      ) : null}
                    </div>
                  </div>
                  {values.hasAltElectricity && (
                    <>
                      <div className="form-group row">
                        <label className="col-md-4 col-form-label">
                          <strong>
                            წყაროს დასახელება
                            {values.hasAltElectricity && (
                              <span style={{ color: '#e55353' }}>*</span>
                            )}
                          </strong>
                        </label>
                        <div className="col-md-8">
                          <input
                            className="form-control"
                            type="text"
                            name="electricitySourceName"
                            placeholder="ენერგიის წყაროს დასახელება"
                            onChange={this.handleChange('electricitySourceName')}
                            value={values.electricitySourceName}
                          />
                          {l ? (
                            <InputInfo
                              descriptions={values.reference_FieldsDescriptions}
                              letterTypeId={this.props.letterTypeId}
                              inputName={'electricitySourceName'}
                            />
                          ) : null}
                          {this.errorExsist('electricitySourceName') ? (
                            <label style={{ fontSize: 10, color: '#e55353' }}>
                              {this.renderErrorText('electricitySourceName')}
                            </label>
                          ) : null}
                        </div>
                      </div>
                      <div className="form-group row">
                        <label className="col-md-4 col-form-label">
                          <strong>
                            წყაროს სიმძლავრე (კვტ)
                            {values.hasAltElectricity && (
                              <span style={{ color: '#e55353' }}>*</span>
                            )}
                          </strong>
                        </label>
                        <div className="col-md-8">
                          <input
                            className="form-control"
                            type="number"
                            name="sourcePower"
                            placeholder="წყაროს სიმძლავრე"
                            onChange={this.handleChange('sourcePower')}
                            value={values.sourcePower}
                            min="0"
                          />
                          {l ? (
                            <InputInfo
                              descriptions={values.reference_FieldsDescriptions}
                              letterTypeId={this.props.letterTypeId}
                              inputName={'sourcePower'}
                            />
                          ) : null}
                          {this.errorExsist('sourcePower') ? (
                            <label style={{ fontSize: 10, color: '#e55353' }}>
                              {this.renderErrorText('sourcePower')}
                            </label>
                          ) : null}
                        </div>
                      </div>
                    </>
                  )}
                  <div className="form-group row">
                    <label className="col-md-4 col-form-label">
                      <strong>
                        ცენტრალური გათბობის სისტემის სქემატური ნახაზი მოცემულია დანართის #3-ში
                      </strong>
                    </label>
                    <div className="col-md-8">
                      <input
                        type="checkbox"
                        onChange={() => this.handleCheck('detailedAppend3')}
                        checked={values.detailedAppend3}
                      ></input>
                      &nbsp;დიახ
                      {l ? (
                        <InputInfo
                          descriptions={values.reference_FieldsDescriptions}
                          letterTypeId={this.props.letterTypeId}
                          inputName={'detailedAppend3'}
                        />
                      ) : null}
                    </div>
                  </div>
                  <div className="form-group row">
                    <label className="col-md-4 col-form-label">
                      <strong>
                        ცენტრალური გათბობის სისტემით მოსარგებლე თითოეულ ობიექტზე განთავსებულია
                        თბოენერგიის ინდივიდუალური მრიცხველი
                      </strong>
                    </label>
                    <div className="col-md-8">
                      <input
                        type="checkbox"
                        onChange={() => this.handleCheck('individualMeter')}
                        checked={values.individualMeter}
                      ></input>
                      &nbsp;დიახ
                      {l ? (
                        <InputInfo
                          descriptions={values.reference_FieldsDescriptions}
                          letterTypeId={this.props.letterTypeId}
                          inputName={'individualMeter'}
                        />
                      ) : null}
                    </div>
                  </div>
                  {values.individualMeter && (
                    <>
                      <div className="form-group row">
                        <label className="col-md-4 col-form-label">
                          <strong>ინდივიდუალური მრიცხველების რაოდენობა</strong>
                          <span style={{ color: '#e55353' }}>*</span>
                        </label>
                        <div className="col-md-8">
                          <input
                            className="form-control"
                            type="number"
                            name="individualMeterQuantity"
                            placeholder="რაოდენობა"
                            onChange={this.handleChange('individualMeterQuantity')}
                            value={values.individualMeterQuantity}
                            min="0"
                          />
                          {l ? (
                            <InputInfo
                              descriptions={values.reference_FieldsDescriptions}
                              letterTypeId={this.props.letterTypeId}
                              inputName={'individualMeterQuantity'}
                            />
                          ) : null}
                          {this.errorExsist('individualMeterQuantity') ? (
                            <label style={{ fontSize: 10, color: '#e55353' }}>
                              {this.renderErrorText('individualMeterQuantity')}
                            </label>
                          ) : null}
                        </div>
                      </div>
                    </>
                  )}
                  {/* { meterTypeNumber: '', stateRegistrationNumber: '' } */}
                  {values.metersList.map((meter, index) => (
                    <React.Fragment key={index}>
                      <div className="form-group row">
                        <label className="col-md-4 col-form-label">
                          {index === 0 ? (
                            <strong>
                              ცენტრალური გათბობის სისტემაში განთავსებული
                              <br />
                              <sub>მრიცხველის ტიპის # და სახელწიფო რეესტრში რეგისტრაციის #</sub>
                            </strong>
                          ) : null}
                        </label>
                        <div className="col-md-3">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="მრიცხველის ტიპის #"
                            name="meterTypeNumber"
                            value={meter.meterTypeNumber}
                            onChange={(e) => this.handleInputChange(e, index)}
                          />
                        </div>
                        <div className="col-md-3">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="სახელწიფო რეესტრში რეგისტრაციის #"
                            name="stateRegistrationNumber"
                            value={meter.stateRegistrationNumber}
                            onChange={(e) => this.handleInputChange(e, index)}
                          />
                        </div>
                        <div className="btn-box col-md-2">
                          {values.metersList.length !== 1 && (
                            <button
                              className=""
                              type="button"
                              onClick={(e) => this.handleRemoveClick(index)}
                            >
                              წაშლა
                            </button>
                          )}
                          &nbsp;
                          {values.metersList.length - 1 === index && (
                            <button
                              type="button"
                              className="btn btn-sm btn-primary"
                              onClick={this.handleAddClick}
                            >
                              დამატება
                            </button>
                          )}
                          {l && index === 0 ? (
                            <InputInfo
                              descriptions={values.reference_FieldsDescriptions}
                              letterTypeId={this.props.letterTypeId}
                              inputName={'tools'}
                            />
                          ) : null}
                        </div>
                      </div>
                    </React.Fragment>
                  ))}
                  <div className="form-group row">
                    <label className="col-md-4 col-form-label">
                      <strong>
                        თბოენერგიის ინდივიდუალური მრიცხველ(ებ)ი არის ინფორმაციის დისტანციურად
                        გადაცემის შესაძლებლობით, რომელიც შეესაბამება-თავსებადია მომსახურე ბუნებრივი
                        გაზის განაწილების ლიცენზიატის მოთხოვნებთან
                      </strong>
                    </label>
                    <div className="col-md-8">
                      <label>
                        <input
                          type="radio"
                          name="remoteTransmission"
                          onChange={() => this.setState({ remoteTransmission: true })}
                          checked={this.state.remoteTransmission}
                        />
                        &nbsp;დიახ
                      </label>
                      &nbsp;&nbsp;&nbsp;&nbsp;
                      <label>
                        <input
                          type="radio"
                          name="remoteTransmission"
                          onChange={() => this.setState({ remoteTransmission: false })}
                          checked={!this.state.remoteTransmission}
                        />
                        &nbsp;არა
                      </label>
                    </div>
                  </div>
                  <div className="form-group row">
                    <label className="col-md-4 col-form-label">
                      <strong>გესაჭიროებათ საგადასახადო ანგარიშ-ფაქტურა</strong>
                    </label>
                    <div className="col-md-8">
                      <label>
                        <input
                          type="radio"
                          disabled={this.state.checkyes_6 ? true : false}
                          onChange={() => {
                            this.handleCheck('checkyes_4');
                          }}
                          checked={this.state.checkyes_4}
                        ></input>
                        &nbsp;დიახ
                      </label>
                      &nbsp;&nbsp;&nbsp;&nbsp;
                      <label>
                        <input
                          type="radio"
                          disabled={this.state.checkyes_6 ? true : false}
                          onChange={() => {
                            this.handleCheck('checkyes_4');
                          }}
                          checked={!this.state.checkyes_4}
                        ></input>
                        &nbsp;არა
                      </label>
                      {l ? (
                        <InputInfo
                          descriptions={values.reference_FieldsDescriptions}
                          letterTypeId={this.props.letterTypeId}
                          inputName={'checkyes_4'}
                        />
                      ) : null}
                    </div>
                  </div>
                  <div className="form-group row">
                    <label className="col-md-12 col-form-label">
                      <strong>
                        განაცხადში მოცემული ჩემი პირადი ნომერი, ტელეფონის ნომერი და ელ. ფოსტის
                        მისამართი :
                      </strong>
                    </label>
                  </div>
                  <div className="form-group row">
                    <label className="col-md-4 col-form-label">
                      <strong>ა)</strong>გამოყენებულ იქნეს გაზმომარაგებასთან დაკავშირებული
                      ინფორმაციის შეტყობინების მიზნით
                    </label>
                    <div className="col-md-8">
                      <label>
                        <input
                          type="radio"
                          onChange={() => {
                            this.handleCheck('checkyes_16');
                          }}
                          checked={this.state.checkyes_16}
                        ></input>
                        &nbsp;დიახ
                      </label>
                      &nbsp;&nbsp;&nbsp;&nbsp;
                      <label>
                        <input
                          type="radio"
                          onChange={() => {
                            this.handleCheck('checkyes_16');
                          }}
                          checked={!this.state.checkyes_16}
                        ></input>
                        &nbsp;არა
                      </label>
                      {l ? (
                        <InputInfo
                          descriptions={values.reference_FieldsDescriptions}
                          letterTypeId={this.props.letterTypeId}
                          inputName={'checkyes_16'}
                        />
                      ) : null}
                    </div>
                    <br />
                    <label className="col-md-4 col-form-group">
                      <strong>ბ)</strong>მიეწოდოს ელექტროენერგიისა და წყალმომარაგების სექტორში
                      მომსახურე საწარმოებს, სადაც, განაცხადში მოცემულ მისამართზე, რეგისტრირებული ვარ
                      მომხმარებლად და გამაჩნია აბონენტის ნომერი
                    </label>
                    <div className="col-md-8">
                      <label>
                        <input
                          type="radio"
                          onChange={() => {
                            this.handleCheck('checkyes_18');
                          }}
                          checked={this.state.checkyes_18}
                        ></input>
                        &nbsp;დიახ
                      </label>
                      &nbsp;&nbsp;&nbsp;&nbsp;
                      <label>
                        <input
                          type="radio"
                          onChange={() => {
                            this.handleCheck('checkyes_18');
                          }}
                          checked={!this.state.checkyes_18}
                        ></input>
                        &nbsp;არა
                      </label>
                      {l ? (
                        <InputInfo
                          descriptions={values.reference_FieldsDescriptions}
                          letterTypeId={this.props.letterTypeId}
                          inputName={'checkyes_18'}
                        />
                      ) : null}
                      <br></br>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-12">
              <div className="card">
                <div className="card-header">
                  <strong>
                    თანდართული დოკუმენტაცია (მხოლოდ pdf/jpg ფაილები, ჯამში მაქსიმუმ 14MB)
                  </strong>
                </div>
                <div className="card-body">
                  <div className="form-horizontal">
                    <div className="form-group row">
                      <label className="col-md-4 col-form-label">
                        <strong>
                          პირადობის მოწმობის ან პასპორტის ასლი
                          <span style={{ color: '#e55353' }}> *</span>
                        </strong>
                      </label>
                      <div className="col-md-8">
                        <input
                          type="file"
                          accept=".pdf, .jpg, .jpeg"
                          onChange={this.handleFileChange('file_1')}
                        ></input>
                        {l ? (
                          <InputInfo
                            descriptions={values.reference_FieldsDescriptions}
                            letterTypeId={this.props.letterTypeId}
                            inputName={'file_1'}
                          />
                        ) : null}
                        {this.errorExsist('file_1') ? (
                          <label style={{ fontSize: 10, color: '#e55353' }}>
                            {this.renderErrorText('file_1')}
                          </label>
                        ) : null}
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-md-4 col-form-label">
                        <strong>
                          ცენტრალური გათბობის სისტემიდან მომარაგებულ ობიექტ(ებ)ის ფართობის შესახებ
                          დეტალური მონაცემები - დანართი #1
                          <span style={{ color: '#e55353' }}> *</span>
                        </strong>
                      </label>
                      <div className="col-md-8">
                        <input
                          type="file"
                          accept=".pdf, .jpg, .jpeg"
                          onChange={this.handleFileChange('file_append1')}
                        ></input>
                        {l ? (
                          <InputInfo
                            descriptions={values.reference_FieldsDescriptions}
                            letterTypeId={this.props.letterTypeId}
                            inputName={'file_append1'}
                          />
                        ) : null}
                        {this.errorExsist('file_append1') ? (
                          <label style={{ fontSize: 10, color: '#e55353' }}>
                            {this.renderErrorText('file_append1')}
                          </label>
                        ) : null}
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-md-4 col-form-label">
                        <strong>
                          ცენტრალური გათბობის სისტემიდან მომარაგებულ ობიექტ(ებ)ზე რეგისტრირებული
                          ელექტროენერგიის მომხმარებლების მიზნობრიობის
                          (საყოფაცხოვრებო-არასაყოფაცხოვრებო) მონაცემები - დანართი #2
                          <span style={{ color: '#e55353' }}> *</span>
                        </strong>
                      </label>
                      <div className="col-md-8">
                        <input
                          type="file"
                          accept=".pdf, .jpg, .jpeg"
                          onChange={this.handleFileChange('file_append2')}
                        ></input>
                        {l ? (
                          <InputInfo
                            descriptions={values.reference_FieldsDescriptions}
                            letterTypeId={this.props.letterTypeId}
                            inputName={'file_append2'}
                          />
                        ) : null}
                        {this.errorExsist('file_append2') ? (
                          <label style={{ fontSize: 10, color: '#e55353' }}>
                            {this.renderErrorText('file_append2')}
                          </label>
                        ) : null}
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-md-4 col-form-label">
                        <strong>
                          ცენტრალური გათბობის სისტემის სქემატური ნახაზი, ამ სისტემით მოსარგებლე
                          პირების, საქვაბისა და ამ სისტემაში ჩართული განახლებადი წყაროების მითითებით
                          დანართის #3
                          <span style={{ color: '#e55353' }}> *</span>
                        </strong>
                      </label>
                      <div className="col-md-8">
                        <input
                          type="file"
                          accept=".pdf, .jpg, .jpeg"
                          onChange={this.handleFileChange('file_systemDrawing')}
                        ></input>
                        {l ? (
                          <InputInfo
                            descriptions={values.reference_FieldsDescriptions}
                            letterTypeId={this.props.letterTypeId}
                            inputName={'file_systemDrawing'}
                          />
                        ) : null}
                        {this.errorExsist('file_systemDrawing') ? (
                          <label style={{ fontSize: 10, color: '#e55353' }}>
                            {this.renderErrorText('file_systemDrawing')}
                          </label>
                        ) : null}
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-md-4 col-form-label">
                        <strong>
                          ბუნებრივი გაზის განაწილების ლიცენზიატთან თბომრიცხველების მონაცემთა
                          გადაცემის პარამეტრები - დანართი #4
                          <span style={{ color: '#e55353' }}> *</span>
                        </strong>
                      </label>
                      <div className="col-md-8">
                        <input
                          type="file"
                          accept=".pdf, .jpg, .jpeg"
                          onChange={this.handleFileChange('file_append4')}
                        ></input>
                        {l ? (
                          <InputInfo
                            descriptions={values.reference_FieldsDescriptions}
                            letterTypeId={this.props.letterTypeId}
                            inputName={'file_append4'}
                          />
                        ) : null}
                        {this.errorExsist('file_append4') ? (
                          <label style={{ fontSize: 10, color: '#e55353' }}>
                            {this.renderErrorText('file_append4')}
                          </label>
                        ) : null}
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="col-md-4 col-form-label">
                        <strong>სხვა დოკუმენტები</strong>
                      </label>
                      <div className="col-md-8">
                        {/* <input className="form-control" onChange={this.handleChange("otherdocuments")} placeholder="სხვა დოკუმენტები"></input>
                         */}
                        <input
                          type="file"
                          accept=".pdf, .jpg, .jpeg"
                          id="otherdocumentsfiles"
                          onChange={this.handleFileChange('otherdocumentsfiles')}
                          multiple
                        ></input>

                        {l ? (
                          <InputInfo
                            descriptions={values.reference_FieldsDescriptions}
                            letterTypeId={this.props.letterTypeId}
                            inputName={'otherdocumentsfiles'}
                          />
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-footer">
                  <div className="row">
                    <div className="col-md-12" style={{ textAlign: 'right' }}>
                      <label>
                        <input
                          type="checkbox"
                          style={{ verticalAlign: 'middle' }}
                          checked={values.agree}
                          onChange={() => this.handleCheck('agree')}
                        ></input>
                        &nbsp;ვეთანხმები
                        <span
                          style={{ color: '#262262', cursor: 'pointer' }}
                          onClick={this.handleLetterTermsModal}
                        >
                          &nbsp;<strong>წესებსა და პირობებს</strong>
                        </span>
                      </label>
                    </div>
                    <br />
                    <br />
                    <div className="col-md-12 col-sm-12">
                      <ReCAPTCHA
                        style={{ float: 'right' }}
                        sitekey={this.props.params.siteKey}
                        onChange={this.handleChange('recaptchaCode')}
                        hl="ka"
                      ></ReCAPTCHA>
                    </div>
                    <br />
                    <br />
                    <div className="col-md-9 col-sm-12"></div>
                    <div className="col-md-3 col-sm-12">
                      <button
                        className="btn btn-primary"
                        id="SendButton"
                        style={{
                          float: 'right',
                          backgroundColor: '#262262',
                          color: 'white',
                        }}
                        disabled={this.state.recaptchaCode && this.state.agree ? false : true}
                        onClick={this.handleSubmit}
                      >
                        გაგზავნა
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      </>
    );
  }
}

export default CentralHeatingAppend2;
